<template>
  <a
    class="contained-icon-button x-link-active"
    :class="{
      active: active
    }"
    @click="handleClick"
  >
    <div class="label-wrapper">
      <slot />
    </div>

    <div class="icon-container">
      <slot name="icon">
        <img
          v-if="active"
          :src="activeImgSrc"
        >
        <img
          v-else
          :src="imgSrc"
        >
      </slot>
    </div>

  </a>
</template>

<script>
export default {
  name: 'IconButton',
  props: {
    imgSrc: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    },
    // active 状态 img 地址
    activeImgSrc: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick () {
      if (this.href) {
        location.href = this.href
      }
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.contained-icon-button {
  display: flex;
  height: 24px;
  border-radius: 8px 12px 12px 8px;
  background: rgba(255,255,255,20%);
  column-gap: 2px;
  font-size: 10px;
  line-height: 10px;

  .label-wrapper {
    display: flex;
    box-sizing: border-box;
    flex-direction: column;
    align-items: flex-end;
    padding: 2px 2px 2px 4px;
  }

  .icon-container {
    display: flex;
    width: 24px;
    height: 24px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: rgba(246,246,246,10%);

    img {
      height: 14px;
    }
  }
}

[data-mode="light"] .contained-icon-button {
  background: rgba(255,255,255,70%);

  .icon-container {
    background: rgba(255,255,255,90%);
  }
}
</style>
